import actionTypes from '../constants/action-types';
import globals from '../../globals';

const synchronizeElement = (elementId) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.SYNCHRONIZE_ELEMENT,
    payload: {
      elementId,
    },
  });

export default synchronizeElement;
